(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function clearMutaeContactSuccessParameter() {
    if (!document.querySelector('[data-contact-success]')) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has('contact_posted')) return;

    url.searchParams.delete('contact_posted');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearMutaeContactSuccessParameter, { once: true });
  } else {
    clearMutaeContactSuccessParameter();
  }

  document.addEventListener('shopify:section:load', clearMutaeContactSuccessParameter);
  } catch(e) { console.error(e); }
})();

})();
